

import React, {
	useState,
	useEffect,
	useContext
} from 'react';

import {
	Box,
	Typography,
	Grid,
	Button,
	Paper,
	Divider,
	DialogContent,
	DialogActions,
	colors
} from '@mui/material';
import { headerSX, descriptionSX } from '../components/common/header-component/style-constant';
import { AppPermissionsContext } from '../components/common/app-context/app-permission-context';
import cbcrMap from '../pages/images/CbCR.png';
import cbcRInfoPDF from '../pages/documents/CbCR_infographic.pdf';
import cbcrGuidance from '../pages/documents/Guidance_of_CbCR.pdf';
import newcbcrMap from '../pages/images/NewCbCR.png';
import backgroundImg from '../pages/images/background.png';
import icon from '../pages/images/icon.png';


const Dashboard = () => {
	const { decoded } = useContext(AppPermissionsContext);

	const cardConfigSx = {
		transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
		borderRadius: '10px',
		boxShadow: 'rgb(159 162 191 / 18%) 0px 9px 16px, rgb(159 162 191 / 32%) 0px 2px 2px',
		alignItems: 'center',
		padding: '3rem',
		width: '70%'
	}

	const contentConfigSx = {
		margin: '0px',
		fontWeight: 300,
		lineHeight: '1.167',
		fontSize: '1.75rem'
	}

	const hyperLinkCard = (content) => (<React.Fragment>
		<Typography
			sx={content.contentsx}
			variant='h1'>
			{content.title}
		</Typography>

		<br />

		<Typography
			sx={content.contentsx}
			variant='h1'>
			<l>
				<li>
					<a target='blank' href={cbcRInfoPDF}>CbCR Filing Guide</a>
				</li>
				<br></br>
				<li>
					<a target='blank' href={cbcrGuidance}>Definitions</a>
				</li>
				<br></br>
				<li>
					<a target='blank' href='https://www.oecd.org/tax/automatic-exchange/country-by-country-exchange-relationships.htm'>Exchange of information</a>
				</li>
				<br></br>
				<li>
					<a target='blank' href='https://www.oecd.org/tax/automatic-exchange/about-automatic-exchange/CbC-MCAA-Signatories.pdf'>Signatories of the MCAA on the exchange of CbCR</a>
				</li>
			</l>
		</Typography>
	</React.Fragment>);

	const contentGenerator = (content) => content.map(f => {
		return (
			<React.Fragment>
				<Box
					sx={{ ...f.sx, width: '100%' }}>
					<Typography
						sx={f.contentsx}
						variant='h1'>
						{(f.type == 'hyperlink' && hyperLinkCard(f) || f.type == undefined && f.title)}
					</Typography>
				</Box>
			</React.Fragment>
		)
	});

	const firstRow = [{
		title: 'CbCR and Pillar Two compliance',
		sx: { ...cardConfigSx, backgroundColor: 'rgb(0, 26, 72)', color: 'rgb(255, 255, 255)' },
		contentsx: { ...contentConfigSx, height: '4rem', alignItems: 'center', display: 'flex', justifyContent: 'center', height: '0rem' }
	}]
	const secondRow = [{
		title: <ul>
			<li><a href='https://www.compareyourcountry.org/tax-cooperation/en/0/623/default'>Countries where MNEs submitted CbCR</a></li>
			<li><a href='https://web-archive.oecd.org/2022-09-12/422190-country-specific-information-on-country-by-country-reporting-implementation.htm'>CbCR reporting requirements & deadlines</a></li>
			<li><a href='https://web-archive.oecd.org/2022-09-12/422190-country-specific-information-on-country-by-country-reporting-implementation.htm'>Overview of reporting requirements per jurisdiction</a></li>
			<li><a href='https://www.oecd.org/en/topics/country-by-country-reporting-for-tax-purposes.html'>Countries that have signed up for CbCR</a></li>
		</ul>,
		sx: {
			...cardConfigSx, backgroundColor: 'rgb(0, 26, 72)', color: 'rgb(255, 255, 255)', paddingTop: '5rem', paddingBottom: '5rem',
			'& a': { fontSize: '25px', color: 'inherit', textDecoration: 'none', '&:visited': { color: 'inherit' }, '&:hover': { textDecoration: 'underline' } }
		},
		contentsx: { ...contentConfigSx, height: '4rem', alignItems: 'center', display: 'flex', justifyContent: 'left' }
	},
	{
		title: <ul>
			<li><a href='https://www.oecd.org/en/publications/tax-challenges-arising-from-digitalisation-of-the-economy-global-anti-base-erosion-model-rules-pillar-two_782bac33-en.html'>Model GloBE Rules</a></li>
			<li><a href='https://www.oecd.org/en/publications/tax-challenges-arising-from-the-digitalisation-of-the-economy-consolidated-commentary-to-the-global-anti-base-erosion-model-rules-2023_b849f926-en.html'>Commentary to the GloBE Rules</a></li>
			<li><a href='https://www.oecd.org/content/dam/oecd/en/topics/policy-sub-issues/global-minimum-tax/administrative-guidance-globe-rules-pillar-two-central-record-legislation-transitional-qualified-status.pdf'>Administrative Guidance</a></li>
			<li><a href='https://www.oecd.org/en/publications/2025/01/tax-challenges-arising-from-the-digitalisation-of-the-economy-globe-information-return-january-2025_b03274ed.html'>GloBE Information Return</a></li>
		</ul>,
		sx: {
			...cardConfigSx, backgroundColor: 'rgb(0, 26, 72)', color: 'rgb(255, 255, 255)', paddingTop: '5rem', paddingBottom: '5rem',
			'& a': { fontSize: '25px', color: 'inherit', textDecoration: 'none', '&:visited': { color: 'inherit' }, '&:hover': { textDecoration: 'underline' } }
		},
		contentsx: { ...contentConfigSx, height: '4rem', alignItems: 'center', display: 'flex', justifyContent: 'left' }
	}]

	const thirdRow = [{
		title: 'Anonymised analytics and insights',
		sx: { ...cardConfigSx, backgroundColor: 'rgb(26, 51, 97)', color: 'rgb(255, 255, 255)' },
		contentsx: { ...contentConfigSx, height: '4rem', alignItems: 'center', fontSize: '25px', display: 'flex', justifyContent: 'left', height: '0rem' }
	},
	{
		title: 'Resource centre',
		sx: { ...cardConfigSx, backgroundColor: 'rgb(26, 51, 97)', color: 'rgb(255, 255, 255)' },
		contentsx: { ...contentConfigSx, height: '4rem', alignItems: 'center', fontSize: '25px', display: 'flex', justifyContent: 'left', height: '0rem' }
	}]

	const fourthRow = [{
		title: <ul>
			<li><a href='https://www.oecd.org/content/dam/oecd/en/publications/reports/2023/11/corporate-tax-statistics-2023_068828ca/f1f07219-en.pdf'>OECD corporate tax statistics</a></li>
		</ul>,
		sx: {
			...cardConfigSx, backgroundColor: 'rgb(26, 51, 97)', color: 'rgb(255, 255, 255)', paddingTop: '4rem', paddingBottom: '4rem',
			'& a': { fontSize: '25px', color: 'inherit', textDecoration: 'none', '&:visited': { color: 'inherit' }, '&:hover': { textDecoration: 'underline' } }
		},
		contentsx: { ...contentConfigSx, height: '4rem', alignItems: 'center', fontSize: '25px', display: 'flex', justifyContent: 'left' }
	},
	{
		title: <ul>
			<li><a href='https://www.oecd.org/content/dam/oecd/en/topics/policy-sub-issues/global-minimum-tax/safe-harbours-and-penalty-relief-global-anti-base-erosion-rules-pillar-two.pdf'>Safe harbours and penalty relief</a></li>
			<li><a href='https://www.oecd.org/content/dam/oecd/en/topics/policy-sub-issues/global-minimum-tax/tax-challenges-arising-from-the-digitalisation-of-the-economy-global-anti-erosion-model-rules-pillar-two-examples.pdf'>Illustrative examples</a></li>
			<li><a href='https://www.oecd.org/content/dam/oecd/en/topics/policy-sub-issues/global-minimum-tax/minimum-tax-implementation-handbook-pillar-two.pdf'>Implementation Handbook</a></li>
			<li><a href='https://www.oecd.org/en/topics/sub-issues/global-minimum-tax/global-anti-base-erosion-model-rules-pillar-two.html#background-material'>Background material</a></li>
		</ul>,
		sx: {
			...cardConfigSx, backgroundColor: 'rgb(26, 51, 97)', color: 'rgb(255, 255, 255)', paddingTop: '4rem', paddingBottom: '4rem',
			'& a': { fontSize: '25px', color: 'inherit', textDecoration: 'none', '&:visited': { color: 'inherit' }, '&:hover': { textDecoration: 'underline' } }
		},
		contentsx: { ...contentConfigSx, height: '4rem', alignItems: 'center', display: 'flex', justifyContent: 'left' }
	}]

	const firstColumn = [
		{
			title: 'Countries where MNEs submitted CbCR',
			sx: {
				...cardConfigSx, height: '13rem', color: 'rgb(0, 26, 72)', paddingTop: '0rem',
				backgroundSize: '26vw 24vh', backgroundRepeat: 'no-repeat',
				backgroundPosition: '-2vw 2vw'
			},
			contentsx: { ...contentConfigSx, height: '3rem', alignItems: 'center', display: 'flex', fontSize: '1.25rem' }
		},
		{
			title: 'Anonymised analytics and insights', sx: { ...cardConfigSx, backgroundColor: 'rgb(0, 26, 72)', color: 'rgb(255, 255, 255)' },
			contentsx: { ...contentConfigSx, height: '6rem', alignItems: 'center', display: 'flex' }
		},
		{
			title: <a target='blank' href='https://www.oecd-ilibrary.org/docserver/f1f07219-en.pdf?expires=1707144696&id=id&accname=guest&checksum=A8FD8BFCECD849A5DA95B228735DDD45'>
				OECD Corporate tax statistics
			</a>,
			sx: { ...cardConfigSx, backgroundColor: 'rgb(255, 255, 255)', color: 'rgb(0, 26, 72)' },
			contentsx: { ...contentConfigSx, height: '3rem', alignItems: 'center', display: 'flex', fontSize: '1.25rem' }
		}
	]

	const secondColumn = [
		{
			title: 'CbCR Reporting Requirements', sx: { ...cardConfigSx, backgroundColor: 'rgb(0, 26, 72)', color: 'rgb(255, 255, 255)' },
			contentsx: { ...contentConfigSx, height: '6rem', alignItems: 'center', display: 'flex' }
		},
		{
			title: <a target='blank' href='https://www.oecd.org/tax/automatic-exchange/country-specific-information-on-country-by-country-reporting-implementation.htm#cbcrequirements'>
				Overview of reporting requirements per jurisdiction</a>,
			sx: { ...cardConfigSx, backgroundColor: 'rgb(255, 255, 255)', color: 'rgb(0, 26, 72)' },
			contentsx: { ...contentConfigSx, height: '3rem', alignItems: 'center', display: 'flex', fontSize: '1.25rem' }
		},
		{
			title: 'Resource center', sx: { ...cardConfigSx, backgroundColor: 'rgb(0, 26, 72)', color: 'rgb(255, 255, 255)' },
			contentsx: { ...contentConfigSx, height: '6rem', alignItems: 'center', display: 'flex' }
		},
		{
			title: 'Countries that have signed up for CbCR',
			sx: {
				...cardConfigSx, height: '13rem', color: 'rgb(0, 26, 72)', paddingTop: '0rem', backgroundImage: `url(${newcbcrMap})`,
				backgroundSize: '26vw 23vh', backgroundRepeat: 'no-repeat',
				backgroundPosition: '-2vw 2vw'
			},
			contentsx: { ...contentConfigSx, height: '3rem', alignItems: 'center', display: 'flex', fontSize: '1.25rem' }
		},

	]

	const thirdColumn = [

		{
			title: 'Outside resource links',
			sx: { ...cardConfigSx, backgroundColor: 'rgb(255, 255, 255)', color: 'rgb(0, 26, 72)' },
			contentsx: { ...contentConfigSx, fontSize: '1.25rem' },
			type: 'hyperlink'
		}
	]

	return (
		<React.Fragment>
			<Box className='container'>
				<Typography
					sx={headerSX}
					component='h3'>
					<span style={{ color: '#ff5d00', justifyContent: 'space-between' }}>
						Hello{` `}
					</span>
					<span style={{ color: 'rgb(255, 255, 255)' }}>
						{decoded.name} {decoded.surname}!
					</span>
				</Typography>
			</Box>

			<Box
				className='container'
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					minHeight: 'calc(100vh - 200px)',
					padding: '2rem',
					ackgroundImage: `url(${backgroundImg})`,
					backgroundSize: '100% 100%',
					backgroundPosition: 'center',
				}}>
				<Box sx={{
					display: 'flex',
					flexDirection: 'column',
					padding: '54px',
					background: 'rgb(255, 255, 255)',
					maxWidth: '800px',
					width: '100%',
					borderRadius: '10px',
					boxShadow: 'rgb(159 162 191 / 18%) 0px 9px 16px, rgb(159 162 191 / 32%) 0px 2px 2px',
					animation: 'fadeIn 1s ease-in',
					'@keyframes fadeIn': {
						'0%': {
							opacity: 0,
							transform: 'translateY(20px)'
						},
						'100%': {
							opacity: 1,
							transform: 'translateY(0)'
						}
					}
				}}>

					{/* <img src='/img/transparent-navy.png'
						alt='Company Logo'
						style={{
							color: 'rgb(34, 51, 84)',
							padding: '0px 9px 0px 0px',
							display: 'flex',
							textDecoration: 'none',
							fontWeight: '700',
							width: '80%',
							maxWidth: '300px',
							marginBottom: '2rem'
						}} /> */}

					< Box >
						<Typography
							variant='h1'
							sx={{
								margin: '0px 0px 30px',
								fontWeight: '700',
								lineHeight: '1.167',
								fontSize: '3.0625rem',
								color: 'rgb(34, 51, 84)',
							}}>
							Transfer Pricing Advisory
						</Typography>

						<Box sx={{ display: 'flex', alignItems: 'flex-start', marginBottom: '27px' }}>
							<img
								src={icon}
								alt="bullet"
								style={{
									width: '24px',
									height: '24px',
									marginRight: '15px',
									marginTop: '5px',
									flexShrink: 0
								}}
							/>
							<Typography
								variant='subtitle1'
								sx={{
									margin: '0px',
									fontSize: '20px',
									color: 'rgba(34, 51, 84, 0.7)',
									fontWeight: '400',
									lineHeight: '1.75',
								}}>
								The Graphene Economics™ platform is an online solution that leverages rich transfer pricing, Country-by-Country, Pillar Two, and other tax-related datasets to provide critical business insights.
							</Typography>
						</Box>

						<Box sx={{ display: 'flex', alignItems: 'flex-start', marginBottom: '27px' }}>
							<img
								src={icon}
								alt="bullet"
								style={{
									width: '24px',
									height: '24px',
									marginRight: '15px',
									marginTop: '5px',
									flexShrink: 0
								}}
							/>
							<Typography
								variant='subtitle1'
								sx={{
									margin: '0px',
									fontSize: '20px',
									color: 'rgba(34, 51, 84, 0.7)',
									fontWeight: '400',
									lineHeight: '1.75',
								}}>
								Our platform delivers descriptive and comparative analytics that help you make sense of routinely collected information, often buried in large spreadsheets, and transform it into meaningful, decision-ready insights.
							</Typography>
						</Box>

						<Box sx={{ display: 'flex', alignItems: 'flex-start', marginBottom: '27px' }}>
							<img
								src={icon}
								alt="bullet"
								style={{
									width: '24px',
									height: '24px',
									marginRight: '15px',
									marginTop: '5px',
									flexShrink: 0
								}}
							/>
							<Typography
								component='div'
								sx={{
									margin: '0px',
									fontSize: '20px',
									lineHeight: '1.75',
									color: 'rgb(34, 51, 84)',
									fontWeight: '700',
								}}>
								Our services span the full transfer pricing lifecycle, covering CbCR and Pillar Two reporting as well as data analytics, including tailored upload solutions.
							</Typography>
						</Box>

						<Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
							<img
								src={icon}
								alt="bullet"
								style={{
									width: '24px',
									height: '24px',
									marginRight: '15px',
									marginTop: '5px',
									flexShrink: 0
								}}
							/>
							<Typography
								component='div'
								sx={{
									margin: '0px',
									fontSize: '20px',
									color: 'rgba(34, 51, 84, 0.7)',
									fontWeight: '400',
									lineHeight: '1.75',
								}}>
								These analytics empower organisations to better visualise their data, strengthen transfer pricing strategies, enhance compliance and mitigate and monitor transfer pricing and certain related tax risks across the group.
							</Typography>
						</Box>
					</Box>
				</Box>
			</Box >
		</React.Fragment >
	);

}

export default Dashboard;
